<head><style>h1, h2, h3, h4, h5, h5 {
  color: #046993;
}

#myBtn {

  position: fixed; /* Fixed/sticky position */
  bottom: 20px; /* Place the button at the bottom of the page */
  right: 30px; /* Place the button 30px from the right */
  z-index: 1999; /* Make sure it does not overlap */
  border: none; /* Remove borders */
  outline: none; /* Remove outline */
  background-color: #046993; /* Set a background color */
  color: white; /* Text color */
  cursor: pointer; /* Add a mouse pointer on hover */
  padding: 10px; /* Some padding */
  border-radius: 10px; /* Rounded corners */
  font-size: 13px; /* Increase font size */
}

.boxshadow {
  position: relative;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, .5);
  padding: 0px;
}

#myBtn:hover {
  background-color: #555; /* Add a dark-grey background on hover */
}
</style>

  <script>
    //Get the button:
    mybutton = document.getElementById("myBtn");

    // When the user scrolls down 20px from the top of the document, show the button
    window.onscroll = function() {scrollFunction()};

    function scrollFunction() {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
      } else {
        mybutton.style.display = "none";
      }
    }

    // When the user clicks on the button, scroll to the top of the document
    function topFunction() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  </script>

</head>

<div style="background-color:#ffffff; margin:-20px; padding: 20px;">
  <div style="margin: -20px;" class="wow zoomIn"><a name="help"></a>
    <img id="top" src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/help-head-01.png" class="img-responsive floattop" alt="Looking up at the top of buildings from street level"/>
  </div>
  <a pageScroll href="#top"><button onclick="topFunction()" id="myBtn" title="Go to top">Back to Top</button></a>
  <h1 id="welcome-to-the-fastlane-help-center">Welcome to the FastLane Help Center!</h1>

  <hr />

  <p>The FastLane Help Center is the best place for a user to go to find answers to typically asked questions when it comes to the FNG system.</p>

  <p>The Help Center is divided into parts:</p>


  <h2 id="quick-tips"><a pageScroll href="#quick-tips-1">Quick Tips</a></h2>

  <ul>
    <li>View tips on Getting Started in FastLane.</li>
    <li>View information on Business and Entertainment Incentive Form Processing.</li>
    <li>View information on Signature Processing and how FastLane uses the Adobe Sign API to process all documents that require execution.</li>
  </ul>


  <h2 id="faqs"><a pageScroll href="#faqs-1">FAQs</a></h2>

  <ul>
    <li>View frequently asked questions about FastLane.</li>
    <li>Watch “How-to” training videos.</li>
  </ul>

  <h2 id="fastlane-applicant-system-guide"><a pageScroll href="#fastlane-applicant-system-guide-1">Fastlane Applicant System Guide</a></h2>

  <ul>
    <li>The FastLane Applicant System Guide is an in-depth explanation of the Applicant screens and business rules in the FastLane system.</li>
  </ul>


  <p><br /></p>
  <br>
  <h2>Contents</h2>

  <hr />
  <ul>
    <li><strong><a pageScroll href="#quick-tips-1">Quick Tips</a></strong>
      <ul>
        <li><a pageScroll href="#getting-started">Getting Started</a></li>
        <li><a pageScroll href="#business-incentives">Business Incentives</a></li>
        <li><a pageScroll href="#entertainment-incentives">Entertainment Incentives</a></li>
        <li><a pageScroll href="#form-processing">Form Processing</a>
          <ul>
            <li><a pageScroll href="#business-incentives-form-processing">Business Incentives Form Processing</a>
              <ul>
                <li><a pageScroll href="#what-is-a-form">What is a form?</a></li>
                <li><a pageScroll href="#form-processing-1">Form Processing</a></li>
                <li><a pageScroll href="#ci-board-processing-in-fastlane">C&amp;I Board Processing in FASTLANE</a></li>
              </ul>
            </li>
            <li><a pageScroll href="#entertainment-incentives-form-processing">Entertainment Incentives Form Processing</a>
              <ul>
                <li><a pageScroll href="#what-is-a-form-1">What is a form?</a></li>
                <li><a pageScroll href="#form-processing-2">Form Processing</a></li>
                <li><a pageScroll href="#initial-and-final-certification-processing">Initial and Final Certification Processing</a>
                  <ul>
                    <li><a pageScroll href="#how-long-does-it-take">How Long Does it Take?</a></li>
                    <li><a pageScroll href="#how-do-i-sign-my-certification">How do I sign my Certification?</a></li>
                  </ul>
                </li>
                <li><a pageScroll href="#signature-processing">Signature Processing</a>
                  <ul>
                    <li><a pageScroll href="#adobe-sign">Adobe Sign</a></li>
                    <li><a pageScroll href="#business-incentive-signature-workflows">Business Incentive Signature Workflows</a></li>
                    <li><a pageScroll href="#entertainment-incentive-signature-workflows">Entertainment Incentive Signature Workflows</a></li>
                    <li><a pageScroll href="#how-to-use-adobe-sign">How to Use Adobe Sign</a></li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </li>
    <li><strong><a pageScroll href="#faqs-1">FAQs</a></strong>
      <ul>
        <li><a pageScroll href="#business-incentive-faqs">Business Incentive FAQs</a></li>
        <li><a pageScroll href="#entertainment-incentive-faqs">Entertainment Incentive FAQs</a></li>
      </ul>
    </li>
    <li><strong><a pageScroll href="#fastlane-applicant-system-guide-1">FastLane Applicant System Guide</a></strong>
      <ul>
        <li><a pageScroll href="#fastlane-system-features">FastLane System Features</a>
          <ul>
            <li><a pageScroll href="#public-features">Public Features</a></li>
            <li><a pageScroll href="#applicant-features">Applicant Features</a></li>
            <li><a pageScroll href="#board-member-features">Board Member Features</a></li>
            <li><a pageScroll href="#assessor-and-external-reviewer-features">Assessor and External Reviewer Features</a></li>
            <li><a pageScroll href="#manager-features-">Manager Features</a></li>
          </ul>
        </li>
        <li><a pageScroll href="#specifications">Specifications</a>
          <ul>
            <li><a pageScroll href="#system-specifications">System Specifications</a></li>
            <li><a pageScroll href="#browser-specifications">Browser Specifications</a></li>
          </ul>
        </li>
        <li><a pageScroll href="#louisiana-economic-development-incentive-programs">Louisiana Economic Development Incentive Programs</a>
          <ul>
            <li><a pageScroll href="#business-incentives-">Business Incentive Programs</a></li>
            <li><a pageScroll href="#entertainment-incentives-">Entertainment Incentive Programs</a></li>
            <li><a pageScroll href="#rd-incentives-">Research &amp; Development Programs</a></li>
          </ul>
        </li>
        <li><a pageScroll href="#public-user-screens">Public User Screens</a>
          <ul>
            <li><a pageScroll href="#landing-page">Landing Page</a></li>
            <li><a pageScroll href="#login">Login</a></li>
            <li><a pageScroll href="#forgot-password">Forgot Password</a></li>
            <li><a pageScroll href="#create-an-account">Create an Account</a></li>
            <li><a pageScroll href="#2fa">Accessing FastLane Using Two-Factor Authentication</a></li>
            <li><a pageScroll href="#document-checklist">Document Checklist</a></li>
          </ul>
        </li>
        <li><a pageScroll href="#applicant-user-screens">Applicant User Screens</a>
          <ul>
            <li><a pageScroll href="#project-list">Project List</a></li>
            <li><a pageScroll href="#add-new-project">Add New Project</a>
              <ul>
                <li><a pageScroll href="#new-project-details">New Project Details</a></li>
                <li><a pageScroll href="#adding-a-business-incentive-project">Adding a Business Incentive Project</a></li>
                <li><a pageScroll href="#adding-an-entertainment-incentive-project">Adding an Entertainment Incentive Project</a></li>
                <li><a pageScroll href="#adding-a-research-and-development-project">Adding a Research &amp; Development Project</a></li>
                <li><a pageScroll href="#project-id">Project ID</a></li>
              </ul>
            </li>
            <li><a pageScroll href="#request-project-access">Request Project Access</a></li>
            <li><a pageScroll href="#account-settings">Account Settings</a></li>
            <li><a pageScroll href="#project-management">Project Management</a>
              <ul>
                <li><a pageScroll href="#project-summary">Project Summary</a>
                  <ul>
                    <li><a pageScroll href="#project-information">Project Information</a></li>
                    <li><a pageScroll href="#important-dates">Important Dates</a></li>
                    <li><a pageScroll href="#forms">Forms</a></li>
                    <li><a pageScroll href="#attachments">Attachments</a></li>
                    <li><a pageScroll href="#project-duration">Project Duration</a></li>
                    <li><a pageScroll href="#advance">Advance</a></li>
                    <li><a pageScroll href="#application">Application</a></li>
                    <li><a pageScroll href="#affidavit-of-final-cost-">Affidavit of Final Cost</a></li>
                    <li><a pageScroll href="#annual-certifications">Annual Certifications</a></li>
                    <li><a pageScroll href="#employee-certifications">Employee Certifications</a></li>
                    <li><a pageScroll href="#external-review-processing">External Review Processing</a></li>
                    <li><a pageScroll href="#board-processing-">Board Processing</a></li>
                    <li><a pageScroll href="#signature-processing-1">Signature Processing</a></li>
                    <li><a pageScroll href="#project-contacts-">Project Contacts</a></li>
                    <li><a pageScroll href="#payments">Payments</a></li>
                  </ul>
                </li>
                <li><a pageScroll href="#what-are-forms">Applicant Forms</a></li>
                <li><a pageScroll href="#research-and-development-forms">Research &amp; Development Forms</a></li>
                <li><a pageScroll href="#system-contact-requirements-">System Contact Requirements</a></li>
                <li><a pageScroll href="#submission-scenarios">Form Submission</a>
                  <ul>
                    <li><a pageScroll href="#submission-scenarios">Submission Scenarios</a>
                      <ul>
                        <li><a pageScroll href="#1-account-holder-is-business-signatory-">(1) Account Holder is Business Signatory</a></li>
                        <li><a pageScroll href="#2-account-holder-is-business-">(2) Account Holder is Business</a></li>
                        <li><a pageScroll href="#3-account-holder-is-consultant-">(3) Account Holder is Consultant</a></li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>

  <br><br><br>
  <div style="margin: -20px;" class="wow zoomIn"><a name="applicant"></a>
    <img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/water-01.png" class="img-responsive" alt="image of fountains"/>
  </div>

  <h2 id="quick-tips-1"><strong>Quick Tips</strong></h2>

  <hr />

  <h3 id="getting-started">Getting Started</h3>

  <p><br /></p>

  <h4 id="business-incentives">Business Incentives</h4>

  <p>Click a topic to watch a short training video on how to get started in Fastlane.</p>

  <ul>
    <li><a href="https://storage.cloud.google.com/fastlane-public-files/Images/Help/Registration.gif">Registering for an Account</a></li>
    <li><a href="https://storage.cloud.google.com/fastlane-public-files/Images/Help/ForgotPassword.gif">Forgot Password</a></li>
    <li><a href="https://storage.cloud.google.com/fastlane-public-files/Images/Help/NewBIProject.gif">Create a Project</a></li>
    <li><a href="https://storage.cloud.google.com/fastlane-public-files/Images/Help/CreateAdvance.gif">Create an Advance Notification</a></li>
  </ul>

  <h4 id="entertainment-incentives">Entertainment Incentives</h4>

  <p>Click a topic to watch a short training video on how to get started in Fastlane.</p>

  <ul>
    <li><a href="https://storage.cloud.google.com/fastlane-public-files/Images/Help/Registration.gif">Registering for an Account</a></li>
    <li><a href="https://storage.cloud.google.com/fastlane-public-files/Images/Help/ForgotPassword.gif">Forgot Password</a></li>
    <li><a href="https://storage.cloud.google.com/fastlane-public-files/Images/Help/NewENTProject.gif">Create a Project</a></li>
  </ul>

  <hr />

  <h2 id="form-processing"><br />Form Processing<a name="forms"></a></h2>

  <h3 id="business-incentives-form-processing">Business Incentives Form Processing<a name="BIforms"></a></h3>

  <h4 id="what-is-a-form">What is a form?</h4>

  <p>Forms are defined as any incentive program document(s) that must be filed, paid for and submitted to Louisiana Economic Development (LED) through FASTLANE. These forms include:</p>

  <ul>
    <li>Advance Notifications</li>
    <li>Applications</li>
    <li>Renewal Applications</li>
    <li>Contract Compliance Forms (i.e., Affidavit of Final Cost (AFC), Project Completion Reports (PCR), Employee Certification Reports (ECR), Annual Certification Reports (ACR), etc.)</li>
    <li>Contract Changes (i.e., Change of Project Location, Change of Company Name, Full Transfer, Partial Transfer, Change of Owners and Affiliates, etc.)</li>
  </ul>

  <h4 id="form-processing-1"><br />Form Processing</h4>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/Artboard%201.png" width="800" class="ml-4 boxshadow" alt="Image describing the relationship between applicant and LED program managers for form approval"/></p>

  <h4 id="ci-board-processing-in-fastlane"><br />C&amp;I Board Processing in FASTLANE<a name="ciforms"></a></h4>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/boardprocess.png" width="800" class="ml-4 boxshadow" alt=" Image of the workflow on approvals: reviewed form goes to Board of Commerce; Board of Commerece makes decision; form or contract sent for esignaure; signed form or contract executed"/></p>

  <p><br /></p>

  <h3 id="entertainment-incentives-form-processing">Entertainment Incentives Form Processing<a name="Entforms"></a></h3>

  <h4 id="what-is-a-form-1">What is a form?</h4>

  <p>Forms are defined as any incentive program document(s) that must be filed, paid for and submitted to Louisiana Economic Development (LED) through FASTLANE. These forms include:</p>

  <ul>
    <li>Applications</li>
    <li>Additional Season Applications</li>
  </ul>

  <h4 id="form-processing-2">Form Processing</h4>

  <p>Managers will only notify applicants about a form status when it is in one of the following:</p>

  <ul>
    <li>Submitted and Received by LED</li>
    <li>“Information Required” - additional information is required to further process the form.</li>
  </ul>

  <hr />

  <p><br /></p>

  <h4 id="initial-and-final-certification-processing">Initial and Final Certification Processing<a name="certprocessing"></a></h4>

  <h5 id="how-long-does-it-take">How Long Does it Take?</h5>

  <p>OEID works to process any and all submissions in a timely manner. The timeframes below are approximations, there may be extenuating circumstance that arise which could extend processing time. If you have any questions about your submission, please don’t hesitate to contact the administrative team.</p>

  <ul>
    <li>Digital Media
      <ul>
        <li>Initial Certifications - 30 to 60 days from receipt of a complete application</li>
        <li>Final Certifications - 60 to 90 days from receipt of complete audit and requested support</li>
      </ul>
    </li>
    <li>FILM
      <ul>
        <li>Initial Certifications - 60 days from receipt of a complete application</li>
        <li>Final Certifications - 120 days from receipt of complete audit and requested support</li>
      </ul>
    </li>
  </ul>

  <h5 id="how-do-i-sign-my-certification">How do I sign my Certification?</h5>

  <p>LED utilizes a tool called Adobe Sign. Adobe Document Cloud solution is a cloud-based, enterprise-class e-signature service that lets you replace paper and ink signature processes with fully automated electronic signature workflows. With it, you can easily send, sign, track, and manage signature processes using a browser or mobile device.</p>

  <p>When a certification is ready for execution, LED will trigger the document workflow through Adobe Sign.</p>

  <p>For <strong>Initial Certifications</strong>, the Business Signatory (project contact) will receive an email notification via email from Adobe from echosign@echosign.com. Follow the instructions in the email, click the provided link, and sign the document via Adobe Sign.</p>

  <p>For <strong>Final Certification Attesations</strong>, the Authorized Representative will receive an email notification via email from Adobe from echosign@echosign.com. Follow the instructions in the email, click the provided link, and sign the document via Adobe Sign.</p>

  <p>For <strong>Final Certifications</strong>, Fastlane will notify the project contacts when the document is executed. Follow the instructions provided in the email and access the executed document via Fastlane.</p>

  <hr />

  <p><br /></p>

  <h4 id="signature-processing">Signature Processing<a name="signprocessing"></a></h4>

  <h5 id="adobe-sign">Adobe Sign</h5>

  <p>Adobe Sign, an Adobe Document Cloud solution is a cloud-based, enterprise-class e-signature service that lets you replace paper and ink signature processes with fully automated electronic signature workflows. With it, you can easily send, sign, track, and manage signature processes using a browser or mobile device.
    Fastlane uses this third-party API to process all documents that require execution.</p>

  <h5 id="business-incentive-signature-workflows">Business Incentive Signature Workflows</h5>

  <p>Business Incentive documents are triggered through the “Send Forms for Signature” page.</p>

  <p><strong>Contracts</strong></p>

  <ol>
    <li>Manager Signature</li>
    <li>Contract Signatory Signature</li>
    <li>Deputy Secretary Signature</li>
    <li>Governor Signature</li>
  </ol>

  <p><strong>Renewal Contracts</strong></p>

  <ol>
    <li>Manager Signature</li>
    <li>Contract Signatory Signature</li>
    <li>Deputy Secretary Signature</li>
    <li>Governor Signature</li>
  </ol>

  <p><strong>Project Complete Reports (PCR)</strong></p>

  <ol>
    <li>Deputy Secretary Signature</li>
  </ol>

  <p><strong>Contract Amendments</strong></p>

  <ol>
    <li>Deputy Secretary Signature</li>
    <li>Contract Signatory Signature</li>
  </ol>

  <h5 id="entertainment-incentive-signature-workflows">Entertainment Incentive Signature Workflows</h5>

  <p>Entertainment documents are triggered through the Initial Cert and Audit screens.</p>

  <p><strong>Initial Certifications</strong></p>

  <ol>
    <li>Manager Review</li>
    <li>Legal Review</li>
    <li>Deputy Secretary Signature</li>
    <li>Manager Signature</li>
    <li>Business Signatory Signature</li>
  </ol>

  <p><strong>Note:</strong> LDR users are hardcoded CCs into the workflow to receive executed cert</p>

  <p><strong>Final Certification Attestations</strong></p>

  <ol>
    <li>Manager Review</li>
    <li>Authorized Representative Signature</li>
  </ol>

  <p><strong>Note:</strong> LDR users are hardcoded CCs into the workflow to receive the DM executed attestation</p>

  <p>Final Certifications**</p>

  <ol>
    <li>Manager Review</li>
    <li>Legal Review</li>
    <li>Deputy Secretary Signature</li>
    <li>Manager Signature</li>
  </ol>

  <p>Note: LDR users are hardcoded CCs into the workflow to receive executed cert</p>

  <h5 id="how-to-use-adobe-sign">How to Use Adobe Sign</h5>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/Help/AdobeSignHowTo.gif" width="800" class="ml-4 boxshadow" alt="Animation showing how to use Adobe Sign for signatures on forms or contracts"/></p>

  <p><br /></p>
  <br><br><br>
  <div style="margin: -20px;" class="wow zoomIn"><a name="applicant"></a>
    <img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/bridge-01.png" class="img-responsive" alt="Photograph of bridge over river" />
  </div>

  <h2 id="faqs-1"><strong>FAQs</strong></h2>

  <h3 id="business-incentive-faqs">Business Incentive FAQs<a name="BIFAQ"></a></h3>

  <ul>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/Registration.gif" target="_blank">How do I register for an Account?</a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/SearchAdvance.gif" target="_blank">How do I search Advance Notification data?</a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/SearchBoardApproved.gif" target="_blank">How do I search Board Approved Project Data?</a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/HowtoViewPublicData.gif" target="_blank">How do I download a dump report of public data?</a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/ForgotPassword.gif" target="_blank">I forgot my password, how can I reset it?</a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/NewBIProject.gif" target="_blank">How do I add a new project to my account?</a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/RequestProjectAccess.gif" target="_blank">How do I add an existing project to my account?</a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/CreateAdvance.gif" target="_blank">How do I create an Advance Notification?</a></li>
    <li>How do I file an Advance Notification?
      <ul>
        <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/FileAdvanceasBusinessSignatory.gif" target="_blank">I am the Business Signatory. </a></li>
        <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/FileAdvanceNotBusinessSignatory.gif" target="_blank">I am a Consultant or Business Contact but NOT the Business Signatory. </a></li>
        <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/HowtoCreateApplication.gif" target="_blank">How do I create an Application?</a></li>
      </ul>
    </li>
    <li>How do I file an Application?
      <ul>
        <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/FileApplicationAsBusinessSignatory.gif" target="_blank">I am the Business Signatory. </a></li>
        <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/FileApplicationNotBusinessSignatory.gif" target="_blank">I am a Consultant or Business Contact but NOT the Business Signatory. </a></li>
      </ul>
    </li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/EditSavedForms.gif" target="_blank">How do I view/edit my saved forms?</a></li>
    <li>I am a Consultant, how do I generate a Disclosure Authorization for a project?
      <ul>
        <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/DAinForm.gif" target="_blank">How to generate a Disclosure Authorization when creating a form.</a></li>
        <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/DAinProjectSummary.gif" target="_blank">How to generate a Disclosure Authorization in the Project Summary. </a></li>
      </ul>
    </li>
    <li>How do I update my Project Contacts?
      <ul>
        <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/EditProjectContactsinForm.gif" target="_blank">How to update Project Contacts within a form.</a></li>
        <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/EditProjectContactsinProjectSummary.gif" target="_blank">How to update Project Contacts in the Project Summary.</a></li>
      </ul>
    </li>
    <li>How do I update the Contract Signatory for a project?
      <ul>
        <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/EditCSinForm.gif" target="_blank">How to update the Contract Signatory within a form.</a></li>
      </ul>
    </li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/AddProjectAttachments.gif" target="_blank">How do I upload attachments to my project?</a><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/PartialTransfer.gif" target="_blank">How do I file a Partial Transfer for my project?</a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/FullTransfer.gif" target="_blank">How do I file a Full Transfer for my project?</a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/ProjectPhase.gif" target="_blank">How do I add a phase to my ITE project?</a></li>

    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/CreateCocForm.gif" target="_blank">How do I file my annual Certification of Compliance?</a></li>
  </ul>

  <p><br /></p>

  <hr />

  <p><br /></p>

  <h3 id="entertainment-incentive-faqs">Entertainment Incentive FAQs<a name="ENTFAQ"></a></h3>

  <p><strong>General</strong></p>

  <ul>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/Registration.gif" target="_blank">How do I register for an account</a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/ForgotPassword.gif" target="_blank">[I forgot my password, how can I reset it?</a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/ProjectAccessRequest.gif" target="_blank">How do I access an existing project that is not in my account? </a></li>
  </ul>

  <p><strong>FILM</strong></p>

  <ul>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/NewENTProject.gif" target="_blank">How do I add a new FILM project to my account?</a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/NewFilmApp.gif" target="_blank">How do I add a FILM Application for my project?</a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/FilmAppASA.gif" target="_blank">How do I add a an Additional Season Application for my FILM project? </a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/FilmAuditDeposit.gif" target="_blank">How do I pay for the required Audit Deposit for FILM? </a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/FilmAppContacts.gif" target="_blank">How do I add contacts to my FILM Application?</a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/FilmAppSubmit.gif" target="_blank">How do I sign and pay for my FILM Application? </a></li>
  </ul>

  <p><strong>DIGITAL MEDIA</strong></p>

  <ul>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/NewENTDMProject.gif" target="_blank">How do I add a new DIGITAL project to my account?</a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/NewDMApp.gif" target="_blank">How do I add a DM Application for my project? </a></li>
    <li>How do I download the Template for Preliminary Schedule of Expenditures?
      <ul>
        <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/DMTemplateDC.gif" target="_blank">From the Document Checklist.</a></li>
        <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/DMTemplateApp.gif" target="_blank">In the application. </a></li>
      </ul>
    </li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/DMTemplateUpload.gif" target="_blank">How do I upload the Template for Preliminary Schedule of Expenditures into the DIGITAL Application?</a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/DMAuditDeposit.gif" target="_blank">How do I pay for the required Audit Deposit for DIGITAL?</a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/DMAppContacts.gif" target="_blank">How do I pay for the required Audit Deposit for DIGITAL?</a></li>
    <li><a href="https://storage.googleapis.com/fastlane-public-files/Images/Help/DMAppSubmit.gif" target="_blank">How do I sign and pay for my DIGITAL?</a></li>
  </ul>

  <p><br /></p>
  <br><br><br>
  <div style="margin: -20px;" class="wow zoomIn"><a name="feature"></a>
    <img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/br-skyline-01.png" class="img-responsive" alt="Photograph showing a city overview " />
  </div>

  <h2 id="fastlane-applicant-system-guide-1">FastLane Applicant System Guide</h2>

  <hr />

  <h3 id="fastlane-system-features">FastLane System Features</h3>

  <h4 id="public-features">Public Features<a name="public"></a></h4>

  <ul>
    <li>Applicant Account Registration</li>
    <li>Public Reporting</li>
  </ul>

  <h4 id="applicant-features">Applicant Features<a name="app"></a></h4>

  <ul>
    <li>Document Checklist for proof required within the applications or compliance forms.</li>
    <li>Ability to create projects and submit all project forms for each project electronically. Available forms are Advance Notifications, Applications, Affidavit of Final Cost (AFC), Project Completion Reports (PCR), Employee Certification Reports (ECR), Annual Certification Reports (ACR), Renewals, Change of Project Location, Change of Company Name, Full Transfer, Partial Transfer, Change of Owners and Affiliates, and Contract Closure.</li>
    <li>Ability to save partial data and finish entry later</li>
    <li>Ability to control electronic guest signature for each form</li>
    <li>Ability to control electronic guest payment using credit cards or echecks for each form</li>
    <li>Ability to track status and activity of all projects and forms</li>
    <li>Email notifications for submittal confirmation, manager review decisions, board notices, board decisions, contract processing, and certification notices.</li>
    <li>Integration with Adobe Sign for electronic contract signature processing</li>
    <li>Ability to request access to manage existing projects with required proof of authorization</li>
    <li>Ability to pay for Verification Report Deposits</li>
    <li>Ability to upload Cost Report and trigger Verification Report Audit by LED selected CPA</li>
  </ul>

  <h4 id="board-member-features">Board Member Features<a name="board"></a></h4>

  <ul>
    <li>Ability to access projects for each board meeting and view details for each application, renewal, or contract change</li>
  </ul>

  <h4 id="assessor-and-external-reviewer-features">Assessor and External Reviewer Features<a name="aer"></a></h4>

  <ul>
    <li>Ability for Department of Revenue, Department of Labor, and Local Governing Authorities the ability to search and review designated projects to aid in interoperability between the state and local agencies.</li>
  </ul>

  <h4 id="manager-features-">Manager Features <a name="manager"></a></h4>

  <ul>
    <li>Project Searching and Reporting across incentives</li>
    <li>Ability to review all project forms</li>
    <li>Ability to manage the external review process</li>
    <li>Ability to manage board process</li>
    <li>Ability to manage contract signature process</li>
    <li>Ability to manage certifications</li>
    <li>Ability to manage payments</li>
    <li>Ability to manage project access</li>
    <li>Ability to manage user accounts</li>
  </ul>

  <p><br /></p>
  <br><br><br>
  <div style="margin: -20px;" class="wow zoomIn"><a name="specs"></a>
    <img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/system-01.png" class="img-responsive" alt="Up close image of computer circuit board"/>
  </div>

  <h3 id="specifications"><strong>Specifications</strong></h3>

  <hr />

  <h4 id="system-specifications">System Specifications<a name="SS"></a></h4>

  <p>FNG (Fastlane Next Generation) is comprised of a front -end and client-side application using Angular 7, a WebAPI using .NetCore and C# language with a MongoDB database. The Angular framework has built-in protections against common web-application vulnerabilities and attacks, such as Cross-site request forgery and Cross-site script inclusion (XSSI) and cross-site scripting (XSS).</p>

  <h4 id="browser-specifications">Browser Specifications<a name="BS"></a></h4>

  <p>FNG works best with the latest versions of Chrome, Safari, and Firefox. The system is also compatible with the latest version of Microsoft Edge but it is not compatible with Microsoft Internet Explorer.
  </p>

  <p><br /></p>
  <br><br><br>
  <div style="margin: -20px;" class="wow zoomIn"><a name="incentives"></a>
    <img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/incentives-01.png" class="img-responsive" alt="Photograph of a city skyline"/>
  </div>

  <h3 id="louisiana-economic-development-incentive-programs"><strong>Louisiana Economic Development Incentive Programs</strong></h3>

  <hr />

  <p>Louisiana’s tax credits and incentive programs give your company a competitive edge.</p>

  <p>For more information, go to: <a href="https://www.opportunitylouisiana.com/business-incentives" target="_blank">https://www.opportunitylouisiana.com/business-incentives.</a></p>

  <h4 id="fastlane-incentive-programs">FastLane Incentive Programs</h4>

  <p>FastLane is the system that manages Louisiana’s business incentive programs that are approved by the Board of Commerce and Industry.</p>

  <h4 id="business-incentives-"><strong>Business Incentives</strong> <a name="BI"></a></h4>

  <ul>
    <li><strong>Enterprise Zone (EZ)</strong> - The Enterprise Zone, or EZ program is a jobs incentive program that provides Louisiana income and franchise tax credits to a new or existing business located in Louisiana creating permanent net new full-time jobs, and hiring at least 50% of those net new jobs from one of four targeted groups. <br />For more information visit: <a href="https://www.opportunitylouisiana.com/business-incentives/enterprise-zone" target="_blank">https://www.opportunitylouisiana.com/business-incentives/enterprise-zone</a></li>
    <li><strong>Industrial Tax Exemption (ITE)</strong> - The Louisiana Industrial Ad Valorem Tax Exemption Program (ITEP) is an original state incentive program, which offers an attractive tax incentive for manufacturers who make a commitment to jobs and payroll in the state. With approval by the Board of Commerce and Industry and local governmental entities, the program provides an 80% property tax abatement for an initial term of five years and the option to renew for five additional years at 80% property tax abatement on a manufacturer’s qualifying capital investment related to the manufacturing process in the state. <br />For more information visit: <a href="https://www.opportunitylouisiana.com/business-incentives/industrial-tax-exemption" target="_blank">https://www.opportunitylouisiana.com/business-incentives/industrial-tax-exemption</a></li>
    <li><strong>Quality Jobs (QJ)</strong> - The Quality Jobs, or QJ, program provides a cash rebate to companies that create well-paid jobs and promote economic development. <br />For more information visit: <a href="https://www.opportunitylouisiana.com/business-incentives/quality-jobs" target="_blank">https://www.opportunitylouisiana.com/business-incentives/quality-jobs</a></li>
    <li><strong>Restoration Tax Abatement (RTA)</strong> - The Restoration Tax Abatement (RTA) program provides an up-to ten-year abatement of property taxes (<em>ad valorem</em>) on renovations and improvements of existing commercial structures and owner-occupied residences located within economic development districts, downtown development districts, historic districts, and opportunity zones. <br />For more information visit: <a href="https://www.opportunitylouisiana.com/business-incentives/restoration-tax-abatement" target="_blank">https://www.opportunitylouisiana.com/business-incentives/restoration-tax-abatement</a></li>
  </ul>

  <h4 id="entertainment-incentives-"><strong>Entertainment Incentives</strong> <a name="ENT"></a></h4>
  <ul>
    <li><strong>Digital Interactive Media and Software Tax Credit (DM or Digital)</strong> - Louisiana’s Digital Interactive Media and Software Program, statutorily known as Digital Interactive Media and Software Tax Credit — the strongest of its kind in the nation — is helping innovative digital media and software development companies of all sizes gain a competitive edge. <br />For more information visit: <a href="https://www.opportunitylouisiana.com/business-incentives/digital-interactive-media-and-software-program" target="_blank">https://www.opportunitylouisiana.com/business-incentives/digital-interactive-media-and-software-program</a></li>
    <li><strong>Motion Picture Production Tax Credit (FILM)</strong> - For applications received on or after July 1, 2017, Louisiana’s Motion Picture Production Program, statutorily known as Motion Picture Production Tax Credit, provides motion picture productions up to a 40% tax credit on total qualified in-state production expenditures, including resident and non-resident labor. For more information visit: <a href="https://www.opportunitylouisiana.com/business-incentives/motion-picture-production-program" targrt="_blank">https://www.opportunitylouisiana.com/business-incentives/motion-picture-production-program</a></li>
  </ul>

  <h4 id="step-incentives-"><strong>State Trade Expansion Program Incentives</strong> <a name="STEP"></a></h4>
  <ul>
    <li><strong>State Trade Expansion Program (STEP)</strong> - Louisiana’s State Trade Expansion Program, statutorily known as STEP Grant — Provides financial awards to state and territory governments to assist small businesses with export development.<br />For more information visit: <a href="https://www.opportunitylouisiana.gov/small-business/special-programs-for-small-business/step-grant" target="_blank">https://www.opportunitylouisiana.gov/small-business/special-programs-for-small-business/step-grant</a></li>
  </ul>

  <h4 id="rd-incentives-"><strong>Research &amp; Development Incentives</strong> <a name="RD"></a></h4>
  <ul>
    <li><strong>Research &amp; Development Tax Credit (R&amp;D)</strong> - Louisiana's Research and Development Tax Credit provides a tax credit to businesses that increase their research and development activities in Louisiana. Dedicated forms are available for small (under 50 employees), growing (50-99 employees), and large (100+ employees) employers, as well as for recipients of federal SBIR/STTR awards. <br />For more information visit: <a href="https://www.opportunitylouisiana.com/business-incentives" target="_blank">https://www.opportunitylouisiana.com/business-incentives</a></li>
  </ul>

  <p><br /></p><br><br><br>
  <div style="margin:-20px;" class="wow zoomIn"><a name="public"></a>
    <img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/public-01.png" class="img-responsive" alt="Photograph looking outwards from a building towards other city buildings"/>
  </div>

  <h3 id="public-user-screens"><strong>Public User Screens</strong></h3>

  <hr />

  <h4 id="landing-page">Landing Page<a name="Land"></a></h4>

  <p>The FNG (Fastlane Next Generation) landing page serves as an introduction to the system. It provides the following:</p>

  <ul>
    <li>Links to public data available for searching</li>
    <li>Links for registration/account creation</li>
    <li>Links to the system login</li>
    <li>System descriptions</li>
    <li>List of available incentives</li>
    <li>Explanation of state-wide interoperability</li>
    <li>Links to the Fastlane Help Center</li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/landing2022-05-03.jpg" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane landing page" /></p>

  <p><br /></p>

  <hr />

  <p><br /></p>

  <h4 id="login">Login<a name="Login"></a></h4>

  <p>All user types will utilize the same portal for system access.</p>

  <p>Account login requires a valid email address and secure password.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/login.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane login form"/></p>

  <p><br /></p>

  <hr />

  <p><br /></p>

  <h4 id="forgot-password">Forgot Password<a name="FP"></a></h4>

  <p>If a user has forgotten their password to the Fastlane system, they need to click “Forgot password?” on the login screen.  The login portal will then transform into the Password Reset. Enter a valid email address and click “Send Reset Link.”</p>

  <p>The system will notify the user that the request has been submitted and that and email will be sent with further instructions.</p>

  <p>If there is no account in the system with the email address entered, the system will send the following email:</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/fp-noemail.png" width="800" class="ml-4 boxshadow" alt="Screenshot of email response showing no matching email address exists in system"/></p>

  <p>If there is an account in the system with the email entered, the system will send the following email:</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/fp.png" width="800" class="ml-4 boxshadow" alt="Screenshot of email response showing a matching email address was found, and how to reset the account password"/></p>

  <p>The link in the email will send the user to the reset password page. Here the user must create a strong password. The system will guide the user with a series of red and green lines below the password field.</p>

  <p>This feature provides a level of security and forces the user to create a secure password which cannot be easily hacked. Once all lines are green, the password can then be reset by click the “Reset” button.</p>

  <p>Also, the make certain the user is typing in the correct password, if the eyeball icon is selected, it will toggle the password visibility to the user.</p>

  <p>Once the password is reset, the use is notified that they will be redirected to the login screen.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/Help/ForgotPassword.gif" width="800" class="ml-4 boxshadow" alt="Animation showing steps to reset password after following the reset password link" /></p>

  <p><br /></p>

  <hr />

  <p><br /></p>

  <h4 id="create-an-account">Create an Account<a name="CreateAcct"></a></h4>

  <p>To create an account, click the Register link on the left-hand navigation menu, or click one of the “Create an Account” buttons on the landing page or login portal.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/createacct.png" width="800" class="ml-4 boxshadow" alt="Screenshot showing where on the Fastlane landing page a user can create an account"/></p>

  <p>The Application User Registration screen is for Application users ONLY. LED Managers, External Reviewers, Assessors and any other user must be created via an LED Manager with account creation permissions. There is a note on the page directing all users other than applicants to contact LED for the account information.</p>

  <p>To create an account, complete the fields noted in red.</p>

  <p>A secure password must be created. Similar to the feature in the Forgot Password area, the system will guide the user with a series of red and green lines below the password field. Once a secure password has been detected, click “Register.” The system will notify the user that the account has been created and that they must verify the email prior to login.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/Help/Registration.gif" width="800" class="ml-4 boxshadow" alt="Animation showing steps necessary to provide information to create a new Fastlane account"/></p>

  <p>The system will send the following email:</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/registeremail.png" width="800" alt="Screenshot showing the confirmation email sent after creating a Fastlane account, this link must be clicked to create the account"/></p>

  <p>The recipient must click the link to verify their email in order to access the account. Once the account has been verified, the use can then click “Continue” and proceed to login.</p>

  <p><br /></p>

  <hr />

  <p><br /></p>


  <h4 id="2fa">Accessing FASTLANE Using Two-Factor Authentication<a name="Accessing FASTLANE Using Two-Factor Authentication"></a></h4>

  <div>
    <p>
      This site requires the use of two-factor authentication. This will require the installation of Google Authenticator on a mobile device.
    </p>
    <p>
      When logging in to FastLane for the first time you will be prompted to setup two-factor authentication AFTER entering your email and password and click the "Log In" button.
    </p>
    <p>
      A UNIQUE QR code will display which can be scanned by your mobile device using the Google Authenticator app.
    </p>
    <p>
      The Google Authenticator app will provide you with codes used to sign into the website. DO NOT DELETE THE GOOGLE AUTHENTICATOR APP AFTER SETUP.
    </p>
    <p>
      Instructions for Android and Apple devices are below.
    </p>
  </div>
  <div class="d-flex flex-row flex-wrap">
    <img src="/assets/two-factor/scan-watermark.png" class="mx-4" height="400" alt="Screenshot showing QR code necessary to configure two factor authentication on Fastlane">
    <img src="/assets/two-factor/validate.PNG" class="mx-4" height="400" alt="Screenshot showing where to input the rotating two factor authentication code to log in to Fastlane">
  </div>

  <div class="d-flex flex-row flex-wrap mt-4">
    <h5 class="text-blue">Android Setup</h5>
  </div>
  <div class="mt-4">
    <p>
      To obtain validation codes a mobile device is needed.
    </p>
    <p>For Android devices the google authenticator app can be found in the appstore.</p>
    <p>
      Once the app is installed you can press the "Scan QR Code" button and scan the QR code shown in the "Set Up
      Two-Factor Authentication" screen.
    </p>
    <p>
      After the QR code is scanned there will be an entry in the Google Authenticator app labeled "FastLane (email
      address)". Below it there is a code that is shown and changes periodically. This code is used to fill out the
      "Validation Code" field on the website.
    </p>
  </div>
  <div class="d-flex flex-row flex-wrap mt-4">
    <img src="/assets/two-factor/PlayStoreDownloadUpdated.jpg" class="mx-4" height="400" alt="Screenshot showing Google Authenticator in the App store to use for two factor authentication">
    <img src="/assets/two-factor/Android-Authenticator.jpg" class="mx-4" height="400" alt="Google authenticator setup screen, showing where to scan a QR code to set up">
    <img src="/assets/two-factor/passcode.jpg" class="mx-4" height="400" alt="Screenshot showing the rotating authentication code after setup is complete">
  </div>



  <div class="d-flex flex-row flex-wrap mt-4">
    <h5 class="text-blue">Apple Setup</h5>
  </div>
  <div class="mt-4">
    <p>
      To obtain validation codes a mobile device is needed.
    </p>
    <p>For Apple devices the google authenticator app can be found in the appstore.</p>
    <p>
      Once the app is installed you can press the "Scan QR Code" button and scan the QR code shown in the "Set Up
      Two-Factor Authentication" screen.
    </p>
    <p>
      After the QR code is scanned there will be an entry in the Google Authenticator app labeled "FastLane (email
      address)". Below it there is a code that is shown and changes periodically. This code is used to fill out the
      "Validation Code" field on the website.
    </p>
  </div>
  <div class="d-flex flex-row flex-wrap mt-4">
    <img src="/assets/two-factor/AppleDownloadUpdated.jpg" class="mx-4" height="400" alt="Screenshot showing Google Authenticator in the App store to use for two factor authentication">
    <img src="/assets/two-factor/AppleAuthenticator.jpg" class="mx-4" height="400" alt="Google authenticator setup screen, showing where to scan a QR code to set up">
    <img src="/assets/two-factor/passcode.jpg" class="mx-4" height="400" alt="Screenshot showing the rotating authentication code after setup is complete">
  </div>

  <div class="d-flex flex-row flex-wrap mt-4">
    <h5 class="text-blue">Google Chrome Setup</h5>
  </div>
  <div class="mt-4">
    <p>
      To obtain validation codes on browsers, an extension is needed.
    </p>
    <p><a href="https://chrome.google.com/webstore/detail/authenticator/bhghoamapcdpbohphigoooaddinpkbai?hl=en-US" target="_blank"> Click here to get the extension</a></p>
    <p>Follow the link above and click "Add to Chrome".</p>
    <p>
      To access the authenticator extension, click the puzzle piece in the top corner and then the "Authenticator" extension.
      Once the authenticator is open, click the pencil in the corner to add your account. Choose "Manual Entry" and enter the code beneath the QR code or choose "Scan QR Code" and click and drag around
      the QR code to scan it.
    </p>
    <p>
      After the code is setup, there will be an entry in the authenticator labeled "FastLane", then a 6 digit code, and finally your email
      address. The code changes periodically and is used to fill out the
      "Validation Code" field on the website.
    </p>
  </div>
  <div class="d-flex flex-row flex-wrap mt-4">
    <img src="/assets/two-factor/AuthenticatorPage.JPG" class="mx-4" width="400" height="100" alt="Screenshot showing where to add the Google Authenticator to Google Chrome web browser">
    <img src="/assets/two-factor/Extensions.png" class="mx-4" height="300" alt="Screenshot showing where to find the installed Authenticator plugin once installed">
    <img src="/assets/two-factor/CodeExample.png" class="mx-4" height="400" alt="Screenshot showing the rotating authentication code after setup is complete">
  </div>


  <p><br /></p>

  <hr />

  <p><br /></p>

  <h4 id="public-reports">Public Reports<a name="PublicReports"></a></h4>

  <p>Public Reports is a series of dump reports for system data. The reports are updated nightly at midnight.</p>

  <p>Currently only the Business Incentive program reports are available.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/publicreports.png" width="800" class="ml-4 boxshadow" alt="Screenshot showing the Public Reports page on Fastlane, describing what reports are available"/></p>

  <p><br /></p>

  <hr />

  <p><br /></p>

  <h4 id="public-search">Public Search<a name="PublicSearch"></a></h4>

  <p>The Public Search is split between Business Incentives and Entertainment Incentives.</p>

  <h4 id="business-incentives-public-search"><strong>Business Incentives Public Search</strong></h4>

  <p>For Business Incentive programs, users have the option to search Advance Notifications or Board Approved Projects.</p>

  <p>To search for Advance Notifications, select the Advance Notification criteria and an incentive program.</p>

  <p>The following filters are also available:</p>

  <ul>
    <li>Program Status</li>
    <li>Parish</li>
    <li>Region</li>
    <li>Advance Received Date</li>
  </ul>

  <p>To view additional details in the search grid, click the blue plus icon on each row.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/Help/SearchAdvance.gif" width="800" class="ml-4 boxshadow" alt="Animated GIF showing how to use the advanced search interface for Advance Notification records in FastLane NextGen"/></p>

  <p>To search Board Approved Projects, click “Board Approved Projects” from the criteria dropdown and select an incentive program. Note – you can only search once program at a time.</p>

  <p>The following filters are also available:</p>

  <ul>
    <li>Program Status</li>
    <li>Parish</li>
    <li>Region</li>
    <li>Application Received Date</li>
    <li>Board Approval Date</li>
    <li>Contract Effective Date</li>
    <li>Contract Expiration Date</li>
    <li>Renewal Contract Effective Date</li>
    <li>Renewal Contract Expiration Date</li>
    <li>Renewal Application Received Date</li>
  </ul>

  <p>To view additional details in the search grid, click the blue plus icon on each row.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/Help/SearchBoardApproved.gif" width="800" class="ml-4 boxshadow" alt="Animated GIF illustrating the search process for Board Approved Project data in the FastLane NextGen portal"/></p>

  <h4 id="entertainment-incentives-public-search"><strong>Entertainment Incentives Public Search</strong></h4>

  <p>To search the Entertainment Incentives Intial Certifications, click the blue fitler button. Then select the desired program. Additional filters of Application Received Date and Initial Cert Issuance Date are also available. Click “search” and the results will display.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/Help/initialcertsearch.gif" width="800" class="ml-4 boxshadow" alt="Animated GIF illustrating the search process for Entertainment Incentives Intial Certifications data in the FastLane NextGen portal" /></p>

  <p><br /></p>

  <hr />

  <p><br /></p>

  <h4 id="document-checklist">Document Checklist<a name="DocCheck"></a></h4>

  <p>The Document Checklist is an up-to-date list of all potential documents needed in preparation for filing incentive applications and forms.</p>

  <p>Click on the desired incentive program to view the corresponding checklist.</p>

  <p>Various templates are available for download. Most are necessary and required to submit specific forms.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/Help/doccheck.gif" width="800" class="ml-4 boxshadow" alt="Animation showing the document checklist page, showing all required documents for submitting an application" /></p>
  <br>
  <br><br><br>
  <div style="margin: -20px;" class="wow zoomIn"><a name="applicant"></a>
    <img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/public-01.png" class="img-responsive" alt="Photograph looking outwards from a building towards other city buildings"/>
  </div>

  <h3 id="applicant-user-screens"><strong>Applicant User Screens</strong></h3>

  <hr />

  <h4 id="project-list">Project List<a name="ProjectList"></a></h4>

  <p>The Project List is the applicant users landing page. This is the up-to-date list of all projects in the account.</p>

  <p>The list identifies each project by the:</p>

  <ul>
    <li>Project ID</li>
    <li>Company &amp; Project Name</li>
    <li>Physical Location</li>
    <li>Project Status</li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/projectlist.png" width="800" class="ml-4 boxshadow" alt="Screenshot of the Fastlane Project List dashboard showing a table of projects with columns for Project ID, Company & Project Name, Physical Location, and Project Status."/></p>

  <p>To view a project’s summary, click the Project ID.</p>

  <p>To quickly add/edit a form, click the blue plus “+” icon for the project.</p>

  <p>The Project List can be filtered as needed using the filter area at the top of the screen, or by using the keyword search located just over the Project ID column.</p>

  <p>Newly created projects will feature a bouncing red exclamation icon. This icon serves as a reminder to applicants that the project is not considered sent/submitted to LED until an Advance or Application form as been submitted. Business Incentive Programs require and Advance Notification. Entertainment Incentives have no Advance Notification; therefore, an Application must be submitted.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/Help/projectlist.gif" width="800" class="ml-4 mb-4 boxshadow" alt="Animated GIF of the Fastlane Project List dashboard: a table displaying projects with columns for Project ID, Company & Project Name, Physical Location, and Project Status, including filter, search, export options, and status badges like 'Project Pending' with alert icons."/></p>

  <p><br /></p>

  <h4 id="add-new-project">Add New Project</h4>

  <hr />

  <h5 id="new-project-details">New Project Details<a name="NewProject"></a></h5>

  <p>To add a new project to an account, click the “Add New Project” option from the left-hand navigation menu.</p>

  <p>A pop-up will display and request the following:</p>

  <ul>
    <li>Incentive Program
      <ul>
        <li>Note – multiple can be selected with the following exceptions.
          <ul>
            <li>EZ and QJ cannot be selected together</li>
            <li>FILM cannot be selected in conjunction with other programs</li>
            <li>STEP Cannot be selected in conjunction with other programs</li>
          </ul>
        </li>
      </ul>
    </li>
    <li>Project Information
      <ul>
        <li>The information requested will change based on the Incentive Program selected.</li>
        <li>For EZ, QJ, RTA, ITE, and DM, the following are requested:
          <ul>
            <li>Company</li>
            <li>Project Name</li>
            <li>Project Location
              <ul>
                <li>Address Line 1</li>
                <li>Address Line 2</li>
                <li>City</li>
                <li>State</li>
                <li>Zip</li>
                <li>Parish</li>
                <li>Inside City Limits (DM does not require this)</li>
              </ul>
            </li>
          </ul>
        </li>
        <li>For FILM, the following are requested:
          <ul>
            <li>Louisiana Production Company</li>
            <li>Production Title</li>
            <li>Permanent Mailing Address
              <ul>
                <li>Address Line 1</li>
                <li>Address Line 2</li>
                <li>City</li>
                <li>State</li>
                <li>Zip</li>
              </ul>
            </li>
            <li>Production Office Address
              <ul>
                <li>Address Line 1</li>
                <li>Address Line 2</li>
                <li>City</li>
                <li>State</li>
                <li>Zip</li>
                <li>Parish</li>
              </ul>
            </li>
          </ul>
        </li>
        <li>For STEP, the following are requested:
          <ul>
            <li>Company</li>
            <li>Company Location
              <ul>
                <li>Address Line 1</li>
                <li>Address Line 2</li>
                <li>City</li>
                <li>State</li>
                <li>Zip</li>
                <li>Parish</li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>

  <h5 id="adding-a-business-incentive-project">Adding a Business Incentive Project<a name="BI"></a></h5>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/Help/NewBIProject.gif" width="800" class="ml-4 boxshadow" alt="Animated process for creating and adding a new Business Incentive project to your FastLane account" /></p>

  <h5 id="adding-an-entertainment-incentive-project">Adding an Entertainment Incentive Project<a name="ENT"></a></h5>
  <h6 id="film"><strong>FILM</strong></h6>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/Help/NewENTProject.gif" width="800" class="ml-4 boxshadow" alt="Animated GIF showing the Fastlane 'Add New Project' form for creating an Enterprise project, including steps to fill in company details, project name, location, contacts, and submission." /></p>

  <h6 id="dm"><strong>DM</strong></h6>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/Help/NewENTDMProject.gif" width="800" class="ml-4 boxshadow" alt="Animated GIF of Fastlane 'Add New Project' form for creating an Enterprise DM (Direct Mail) project, showing entry of company/project details, location, contacts, DM-specific options, and form submission."/></p>


  <h5 id="adding-an-state-trade-expansion-program">State Trade Expansion Program<a name="STEP"></a></h5>
  <h6 id="step"><strong>STEP</strong></h6>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/AddNewProjectAddingAStep.gif" width="800" class="ml-4 boxshadow" alt="Animated GIF of Fastlane 'Add New Project' interface demonstrating how to add a new step or phase: clicking an 'Add Step' button, entering step details (e.g., name, description, date), and saving it to the project form." /></p>

  <p>Once the requested fields are completed and the new project is saved. The user is brought back to the project list where the new project will display at the top of the list, and a small toaster alert will display at the top right-hand corner of the screen.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/projectcreated.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane Project List after creating a new project: a green 'Project created!' success notification with checkmark and OK button appears at the top right, above the searchable project table listing entries like 'Testing Project' (Pending) and others."/></p>

  <p>Projects that are created together will have the same project number but will be followed by a different acronym per incentive program.</p>

  <h5 id="adding-a-research-and-development-project">Adding a Research &amp; Development Project<a name="RD"></a></h5>

  <p>Under INCENTIVE PROGRAMS, check <strong>RD</strong>, complete the project information, and click SAVE. Then, from the Manage Project Forms page, add one of the four Research &amp; Development application forms — 6765 LQRE (Under 50 Employees), 6765 LQRE Increase (50-99 Employees), 6765 LQRE (100+ Employees), or SBIR/STTR. Only one may be added per project.</p>

  <p><img src="assets/images/help/rd/rd-add-project.gif" width="800" class="ml-4 boxshadow" alt="Animated GIF showing how to create a Research and Development project in FastLane and add a 6765 LQRE application form." /></p>

  <p><strong>Note:</strong> The RD ID is assigned by the Research &amp; Development manager while processing the application.</p>

  <h5 id="project-id">Project ID<a name="ProjectID"></a></h5>

  <p>The Project ID (also known as contract number) is a system generated number that is the is the year the project was created followed by four numbers ending in the hyphenated incentive program abbreviation.</p>

  <p>Project Phases will add the hyphenated phase letter designation before the incentive program.</p>

  <p>Partial Transfers will add “-PT” before the incentive program.</p>

  <p>Examples: 20009999-ITE, 20009999-A-ITE, 20009999-PT-ITE, and 20009999-A-PT-ITE</p>

  <p><strong>Note:</strong> The Entertainment ID for FILM and DM are assigned by the Entertainment Incentive manager while processing the application.</p>
  <p><strong>Note:</strong> The STEP ID for STEP programs are assigned by the STEP manager while processing the application.</p>

  <p><br /></p>

  <hr />

  <p><br /></p>

  <h4 id="request-project-access">Request Project Access<a name="projectaccess"></a></h4>

  <p>If a user needs to access to a project that is not currently in the Project List, the user needs to request access to the project.</p>

  <p>To request access, enter the Project ID and search for the project. This must be the Project ID and not the Entertainment ID.</p>

  <p>If the Project ID is correct, additional information will be required.</p>

  <p>If the account holder is considered a “Third Party Consultant” to the project which they are requesting access, they must answer “Yes” and attach proof they have permission from the company to access this project.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/Help/RequestProjectAccess.gif" width="800" class="ml-4 boxshadow" alt="Animated step-by-step guide showing how to request access to an existing project in FastLane NextGen, including searching by project number and submitting the request" /></p>

  <p><strong><em>All access requests are reviewed by LED Managers. The approval process is NOT immediate. This can typically take 24-48 hours.</em></strong></p>

  <p>The user is notified on screen when the request is submitted. The system will also send an email to the LED Manager for the corresponding incentive program.</p>

  <p>Whether the access request is approved or denied, the user will be notified via email.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/projectaccessapprove.png" width="800" class="ml-4 boxshadow" alt="Project Access Request for user Beta Tester, with details on the approved project and a link to view the project list."/></p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/projectaccessdeny.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane project access denial notification: 'Project Access Request - Denied' for user Beta Tester, stating the request has been denied and the user does not have access, with contact info for support." /></p>

  <p><br /></p>

  <hr />

  <p><br /></p>

  <h3 id="account-settings">Account Settings<a name="Acct"></a></h3>

  <p>To view the account settings, click the blue human icon on the top right corner of the screen, then click Account Settings.</p>

  <p>To change the password, click “Change Password” and the screen will toggle for a new password to be entered.</p>

  <p>Any changes made to this page, must be saved by clicking “Update.” When the changes are successfully updated, a notification will display.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/Help/AcctSettings.gif" width="800" class="ml-4 boxshadow" alt="Animated Gif of various screens showing account management setting options."/></p>

  <p><br /></p>

  <h3 id="project-management">Project Management</h3>

  <hr />

  <h4 id="project-summary">Project Summary<a name="ProjectSummary"></a></h4>

  <p>The Project Summary is an up-to-date detailed summary view of the project. The summary contains the following components:</p>

  <ul>
    <li>Project Information</li>
    <li>Important Dates</li>
    <li>Forms</li>
    <li>Attachments</li>
    <li>Project Duration</li>
    <li>Advance</li>
    <li>Application</li>
    <li>Affidavit of Final Cost</li>
    <li>Annual Certifications</li>
    <li>Employee Certifications</li>
    <li>External Review Processing</li>
    <li>Board Processing</li>
    <li>Signature Processing</li>
    <li>Project Contacts</li>
    <li>Payments</li>
    <li>Related Projects</li>
  </ul>

  <p><strong>Note:</strong> certain components are specific to individual incentive programs and will only display on the respective Project Summary.</p>

  <p>The Project Summary also features an Additional Action/Hamburger menu, which contains additional menu options needed to manage the project.</p>

  <p>The menu options are:</p>

  <ul>
    <li>View Project Summary</li>
    <li>Manage Forms</li>
    <li>Update Project General Information</li>
    <li>Update Project Contract Signee</li>
    <li>Update Project Contacts</li>
    <li>Manage Attachments</li>
    <li>Generate Consultant Disclosure Authorization</li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/hamburgermenu.png" width="800" class="ml-4 boxshadow" alt="Image showing location of hamburger navigation menu inside the project summary screen." /></p>

  <p><br /></p>

  <h5 id="project-information">Project Information<a name="PSProjectInfo"></a></h5>

  <p>The Project Information section displays the identifying project details. Typically, this will be Company, Project Name and Location. However, it can also include other identifying information specific to the incentive program. The Project Information is collected at the time of project creation, so the information collected at that step, is what displays in this card.</p>

  <p><strong>Business Incentive Program Project Information</strong></p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/BIprojectInfo.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane project details page for an Entertainment Incentive Program project (e.g., RTA type), showing 'Project Information' with company name, project name, and location fields, plus 'Important Dates' sidebar."/></p>

  <p><strong>Entertainment Incentive Program Project Information</strong></p>

  <h6><strong>FILM</strong></h6>
  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/filmprojectinfo.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane Film incentive project details page, displaying production company, title, permanent mailing address, production office address, and other film-specific fields."/></p>

  <h6><strong>DM</strong></h6>
  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/dmprojectinfo.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane Digital Media (DM) project details page, showing company, project name, and location information for an active DM project."/></p>

  <p><strong>State Trade Expansion Program Project Information</strong></p>

  <h6><strong>STEP</strong></h6>
  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/stepprojectinfo.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane State Trade Expansion Program (STEP) project details page, including company address, important dates, and a forms table section."/></p>

  <p><strong>Research &amp; Development Program Project Information</strong></p>

  <h6><strong>R&amp;D</strong></h6>
  <p><img src="assets/images/help/rd/rd-project-info.png" width="800" class="ml-4 boxshadow" alt="Screenshot of a FastLane Research and Development project details page, showing company, project name, location, and the RD ID." /></p>

  <p><br /></p>

  <h5 id="important-dates">Important Dates<a name="PSImportantDates"></a></h5>

  <p>The Important Dates component shows all critical and upcoming dates associated with the project. As with the Project Information, these dates are specific to the incentive program. Shown below is an example of a Business Incentive Important Dates card.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/importantdates.png" width="800" class="ml-4 boxshadow" alt="Screenshot of the 'Important Dates' section in a Fastlane project details page, listing key milestone dates such as Advance Received, Application Received, Contract Executed, and various due/expiration dates."/></p>

  <p><br /></p>

  <h5 id="forms">Forms<a name="PSForms"></a></h5>

  <p>The Forms component displays all forms in the project. To view the individual forms, click the form name. To view the submission history, click the blue icon under the Status History column.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/forms-1.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane 'Forms' section in project details, displaying a table of submitted forms with columns for Form name, Qualifier, Date Created, Date Received, Status, Comment, and Status History." /></p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/forms-2.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane 'Forms' section (continued view), highlighting additional or expanded form entries with statuses, dates, and details."/></p>

  <p><br /></p>

  <h5 id="attachments">Attachments<a name="PSAttach"></a></h5>

  <p>The Attachments component displays all attachments uploaded to the project. To download the attachment, click the blue download icon.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/attach.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane 'Attachments' section, listing uploaded files with download icons."/></p>

  <p><br /></p>

  <h5 id="project-duration">Project Duration<a name="PSProjectDuration"></a></h5>

  <p>The Project Duration component displays the project start and end dates submitted on the Advance, Application and Project Completion Report (PCR).</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/duration.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane 'Project Duration' section showing start and end dates from Advance, Application, and PCR." /></p>

  <p><br /></p>

  <h5 id="advance">Advance<a name="PSAdvance"></a></h5>

  <p>The Advance component provides a summarized view of estimated investments, jobs and payroll data entered on the Advance form. If the incentive program doesn’t require an Advance, this section will not display.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/ps-advance.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane 'Advance' summary showing estimated investments, jobs, and payroll data."/></p>

  <p><br /></p>

  <h5 id="application">Application<a name="PSApplication"></a></h5>

  <p>The Application component provides a summarized view of estimated investments, jobs and payroll data entered on the Application form, as well as the estimated benefit(s). Scroll over the info icon to see the benefit breakdown.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/ps-application.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane 'Application' summary with estimated investments, jobs, payroll, and benefits."/></p>

  <p><br /></p>

  <h5 id="affidavit-of-final-cost-">Affidavit of Final Cost <a name="PSAFC"></a></h5>

  <p>The Affidavit of Final Cost component provides the summaries view of the final investments for the project. If the incentive program does not require and AFC, this section will not display.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/ps-afc.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane 'Affidavit of Final Cost' (AFC) summary with final certified investments and data."/></p>

  <p><br /></p>

  <h5 id="annual-certifications">Annual Certifications<a name="PSACR"></a></h5>

  <p>For the QJ program, the Annual Certification component is a summarized view of the Annual Certification Report data, submitted yearly per contract requirement.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/ps-acr.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane 'Annual Compliance Report' (ACR) section, summarizing yearly compliance data including investments, jobs, payroll, and status for ongoing project monitoring." /></p>

  <p><br /></p>

  <h5 id="employee-certifications">Employee Certifications<a name="PSECR"></a></h5>

  <p>For the EZ and QJ programs, the Employee Certification component is a summarized view of the Employee Certification Report data, submitted yearly per contract requirement.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/ps-ecr.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane 'Employee Certifications' (ECR) section, listing yearly employee certification report summaries with status and job data for EZ/QJ incentive programs."/></p>

  <p><br /></p>

  <h5 id="external-review-processing">External Review Processing<a name="PSERs"></a></h5>

  <p>Certain incentive programs (EZ, ITE, QJ and RTA) require external evaluation of forms prior to being added to a board agenda. The External Review Processing component provides an up-to-date view of where forms are in the external review process, including the agency, current status, status date, date sent for review and a status history. To view the status history, click the status history icon. If there is no external review process for an incentive program, this section will not display.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/ps-er.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane 'External Review Processing' section, tracking form review status by external agencies for EZ, ITE, QJ, and RTA programs."/></p>

  <p><br /></p>

  <h5 id="board-processing-">Board Processing <a name="PSBoard"></a></h5>

  <p>Certain incentive programs (EZ, ITE, QJ and RTA) require board approval before a contract can be issued. The Board Processing component provides an up-to-date view of where forms are in the Board process, including form type, board date, board status and comment (if available.) If there is no Board process for an incentive program, this section will not display.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/ps-board.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane 'Board Processing' section, showing form status and dates for board approval in EZ, ITE, QJ, and RTA programs."/></p>

  <h5 id="signature-processing-1"><br />Signature Processing<a name="PSSign"></a></h5>

  <p>The Signature Processing component provides an up-to-date view of where documents are in the signature process, including document type, date sent, signature status, history and download. To view the signature history, click the blue icon. To download the executed document, click the blue download icon.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/ps-sign.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane 'Signature Processing' section, listing documents with signature status, history, and download options."/></p>

  <p><br /></p>

  <h5 id="project-contacts-">Project Contacts <a name="PSContacts"></a></h5>

  <p>The Project Contact component shows all current contacts attached to the particular project. Details provided include Contact Name, Email Address, Company Name, Mailing Address, Phone Number and Contact Type. For further explanation on Contact Type, see the <a pageScroll href="#system-contact-requirements-">System Contact Requirements</a> section.</p>

  <p><br /></p>

  <h5 id="payments">Payments<a name="PSPay"></a></h5>

  <p>The Payments component displays all payments made in this project. This serves as a “receipt” to and an area to track is payment was complete on a particular form. The component provides the Fee Type, Amount Paid, Date Received, Confirmation #, and Transaction Type.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/ps-payments.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane 'Payments' section in project details, displaying a table of paid fees including Advance, Application, ECR, and PCR with amounts, dates received, and transaction types."/><br /><br /></p>

  <hr />

  <p><br /></p>

  <h4 id="what-are-forms">What Are Forms?<a name="Forms"></a></h4>

  <p>A form is defined as any incentive program document(s) that must be filed, paid for and submitted to Louisiana Economic Development (LED) through FASTLANE. These forms include:</p>

  <ul>
    <li>Advance Notifications</li>
    <li>Applications</li>
    <li>Renewal Applications</li>
    <li>Contract Compliance Forms (i.e., Affidavit of Final Cost (AFC), Project Completion Reports (PCR), Employee Certification Reports (ECR), Annual Certification Reports (ACR), etc.)</li>
    <li>Contract Changes (i.e., Change of Project Location, Change of Company Name, Full Transfer, Partial Transfer, Change of Owners and Affiliates, etc.)</li>
  </ul>

  <p>Available forms depend on two factors – 1) Incentive Program and 2) stage of project.</p>

  <h4 id="available-forms">Available Forms<a name="Forms2"></a></h4>

  <table style="width: 100%;" border="1" cellspacing="5" cellpadding="5">
    <tbody>
      <tr>
        <td width="185">
          <p><strong>Form Name</strong></p>
        </td>
        <td width="30">
          <p><strong>EZ</strong></p>
        </td>
        <td width="36">
          <p><strong>QJ</strong></p>
        </td>
        <td width="36">
          <p><strong>ITE</strong></p>
        </td>
        <td width="41">
          <p><strong>RTA</strong></p>
        </td>
        <td width="44">
          <p><strong>FILM</strong></p>
        </td>
        <td width="36">
          <p><strong>DM</strong></p>
        </td>
        <td width="36">
          <p><strong>STEP</strong></p>
        </td>
        <td width="214">
          <p><strong>Note</strong></p>
        </td>
      </tr>
      <tr>
        <td width="185">
          <p>Advance</p>
        </td>
        <td width="30">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="41">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="44">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="214">
          <p>Can be created until submitted.</p>
        </td>
      </tr>
      <tr>
        <td width="185">
          <p>Application</p>
        </td>
        <td width="30">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="41">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="44">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="214">
          <p>For BI &ndash; Can be created after Advance is submitted.</p>
          <p>For ENT &ndash; Can be created Manage Project Forms page until submitted.</p>
        </td>
      </tr>
      <tr>
        <td width="185">
          <p>Renewal Application</p>
        </td>
        <td width="30">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="41">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="44">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="214">
          <p>Available for creation on Manage Project Forms page after Application has been submitted.</p>
        </td>
      </tr>
      <tr>
        <td width="185">
          <p>Additional Season Application</p>
        </td>
        <td width="30">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="41">
          <p>&nbsp;</p>
        </td>
        <td width="44">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="214">
          <p>Can be added as needed on Manage Project Forms page.</p>
        </td>
      </tr>
      <tr>
        <td width="185">
          <p>Project Extension Request</p>
        </td>
        <td width="30">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="41">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="44">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="214">
          <p>Available for creation on Manage Project Forms page as needed, after the Application has been submitted. Once Project Status is Contract Pending, this form is no longer available.</p>
        </td>
      </tr>
      <tr>
        <td width="185">
          <p>Affidavit of Final Cost (AFC)</p>
        </td>
        <td width="30">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="41">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="44">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="214">
          <p>Available for creation on Manage Project Forms page as needed, after the Application has been submitted.</p>
        </td>
      </tr>
      <tr>
        <td width="185">
          <p>Project Completion Report (PCR)</p>
        </td>
        <td width="30">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="41">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="44">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="214">
          <p>Available for creation on Manage Project Forms page as needed, after the Application has been submitted.</p>
        </td>
      </tr>
      <tr>
        <td width="185">
          <p>Audit</p>
        </td>
        <td width="30">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="41">
          <p>&nbsp;</p>
        </td>
        <td width="44">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="214">
          <p>Form is created on Manage Project Forms page when the Audit Deposit is paid.</p>
        </td>
      </tr>
      <tr>
        <td width="185">
          <p>Employee Certification Report (ECR)</p>
        </td>
        <td width="30">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="41">
          <p>&nbsp;</p>
        </td>
        <td width="44">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="214">
          <p>Available for creation on Manage Project Forms page as needed, after the Application has been submitted.</p>
        </td>
      </tr>

      <tr>
        <td width="185">
          <p>Certificate Of Compliance (COC)</p>
        </td>
        <td width="30">
          <p>
            <strong>&nbsp;</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>&nbsp;</strong>
          </p>
        </td>
        <td width="36">
          <p>✔	</p>
        </td>
        <td width="41">
          <p>&nbsp;</p>
        </td>
        <td width="44">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="214">
          <p>Available for creation on Manage Project Forms page as needed, after the Application has been submitted.</p>
        </td>
      </tr>

      <tr>
        <td width="185">
          <p>Annual Certification Report (ACR)</p>
        </td>
        <td width="30">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="41">
          <p>&nbsp;</p>
        </td>
        <td width="44">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="214">
          <p>Available for creation on Manage Project Forms page as needed, after the Application has been submitted.</p>
        </td>
      </tr>
      <tr>
        <td width="185">
          <p>Partial Transfer of Ownership to New Company</p>
        </td>
        <td width="30">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="41">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="44">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="214">
          <p>Available for creation on Manage Project Forms page as needed, after the Application has been submitted.</p>
        </td>
      </tr>
      <tr>
        <td width="185">
          <p>Full Transfer of Ownership to New Company</p>
        </td>
        <td width="30">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="41">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="44">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="214">
          <p>Available for creation on Manage Project Forms page as needed, after the Application has been submitted.</p>
        </td>
      </tr>
      <tr>
        <td width="185">
          <p>Change of Company Name</p>
        </td>
        <td width="30">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="41">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="44">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="214">
          <p>Available for creation on Manage Project Forms page as needed, after the Application has been submitted.</p>
        </td>
      </tr>
      <tr>
        <td width="185">
          <p>Change of Project Physical Location</p>
        </td>
        <td width="30">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="41">
          <p>&nbsp;</p>
        </td>
        <td width="44">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="214">
          <p>Available for creation on Manage Project Forms page as needed, after the Application has been submitted.</p>
        </td>
      </tr>
      <tr>
        <td width="185">
          <p>Change of Affiliates/Owners</p>
        </td>
        <td width="30">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p><strong>&nbsp;</strong></p>
        </td>
        <td width="41">
          <p>&nbsp;</p>
        </td>
        <td width="44">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="214">
          <p>Available for creation on Manage Project Forms page as needed, after the Application has been submitted.</p>
        </td>
      </tr>
      <tr>
        <td width="185">
          <p>Contract Closure</p>
        </td>
        <td width="30">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="36">
          <p>
            <strong>✔	</strong>
          </p>
        </td>
        <td width="41">
          <p>&nbsp;</p>
        </td>
        <td width="44">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="36">
          <p>&nbsp;</p>
        </td>
        <td width="214">
          <p>Available for creation on Manage Project Forms page, after the Application has been submitted.</p>
        </td>
      </tr>
    </tbody>
  </table>

  <p><br /></p>

  <h4 id="creating-forms">Creating Forms<a name="CreateForms"></a></h4>

  <p>Forms are added and edited on the Manage Project Forms page. This page is accessible to applicant users from the Project List and Project Summary.</p>

  <p>To access the Manage Project Forms page by the Project List, click the blue plus icon for the corresponding project.</p>

  <p>To access the Manage Project Forms page by the Project Summary, click the Project ID.</p>

  <p>Then once in the Project Summary, click the hamburger menu in the top right-hand corner of the screen. From there, the select “Manage Forms.”</p>

  <p>Once on the Manage Project Forms page, select the form type from the dropdown and click “Add.” See <a href="#Forms2">Available Forms by Program</a> in the previous section for the notes on when each form is available for creation.</p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/Help/CreatingForms.gif" width="800" class="ml-4 boxshadow" alt="Animated GIF of Fastlane demonstrating how to create and submit a new form: selecting a project from the Project List, accessing the forms section, choosing a form type (e.g., Advance or Application), filling required fields, and submitting with confirmation."/></p>

  <p><br /></p>

  <hr />

  <p><br /></p>

  <h4 id="research-and-development-forms">Research &amp; Development Forms<a name="RDForms"></a></h4>

  <p>Louisiana's Research &amp; Development Tax Credit is filed on one of four application forms. Add the one that matches your business — only one may be added per project:</p>
  <ul>
    <li><strong>6765 LQRE (Under 50 Employees)</strong></li>
    <li><strong>6765 LQRE Increase (50-99 Employees)</strong></li>
    <li><strong>6765 LQRE (100+ Employees)</strong></li>
    <li><strong>SBIR/STTR</strong></li>
  </ul>
  <p>A fifth form, the <strong>Examination</strong>, is initiated by your LED program manager when additional documentation is needed; it is described at the end of this section.</p>

  <h5 id="rd-completing-the-application">Completing the Application</h5>
  <p>Open the form from the Manage Project Forms page and complete each section, saving as you go:</p>
  <ul>
    <li><strong>Business Information</strong> — company and filing details. Additional fields appear based on your answers (for example, a controlled group reveals the controlling entity, and a fiscal-year filer reveals the fiscal year end).</li>
    <li><strong>Research and Development Information</strong> — details about the R&amp;D activities. If any research took place out of state, you will be asked to list where.</li>
    <li><strong>Research and Development Tax Credit Calculation</strong> — download the calculation workbook that matches your form, complete it, and import it (see below).</li>
  </ul>

  <h5 id="rd-importing-the-calculation">Importing the Tax Credit Calculation</h5>
  <p>In the Research and Development Tax Credit Calculation section, download the workbook template for your form type, complete it, and click <strong>Import Calculation Workbook</strong>. The imported figures populate the on-screen calculation and the Louisiana Research Credit. Import the workbook that matches your form — other tiers' workbooks are not accepted. Re-importing overwrites the calculation and saves the workbook again as an attachment. A $0 or negative Louisiana Research Credit cannot be imported.</p>
  <p><img src="assets/images/help/rd/rd-import-calculation.gif" width="800" class="ml-4 boxshadow" alt="Animated GIF showing how to import the Research and Development tax credit calculation workbook on a FastLane form." /></p>

  <h5 id="rd-attachments-and-contacts">Attachments &amp; Project Contacts</h5>
  <p>Add the documents listed on the form's <a pageScroll href="#document-checklist">Document Checklist</a> from the Attachments card while the form is editable. On Project Contacts, add a <strong>Business</strong> contact and a <strong>Business Signatory</strong> contact (a person with authority to sign). A Business Signatory is required before the form can be sent for signature.</p>

  <p><br /></p>

  <hr />

  <p><br /></p>

  <h4 id="system-contact-requirements-">System Contact Requirements <a name="ContactReq"></a></h4>

  <p>FNG has three Contact Types – Business Signatory, Business, and Consultant.</p>

  <h5 id="business-signatory--required">Business Signatory — REQUIRED</h5>

  <p>The Business Signatory MUST have legal authority to sign project forms. The Business Signatory contact type is required to electronically sign various forms throughout the course of the project.</p>

  <p>The Business Signatory is/has:</p>

  <ul>
    <li>Legal signature authority</li>
    <li>Authorized Representative for Company/Project</li>
  </ul>

  <p>The Business Signatory contact person CANNOT sign Contract documents unless they are designated as the CONTRACT SIGNATORY in the Project.</p>

  <p>There can only be ONE Business Signatory.</p>

  <h5 id="business">Business</h5>

  <p>The Business contact type is any person that needs to be contacted regarding a project.</p>

  <p>There can be multiple Business contacts.</p>

  <h5 id="consultant">Consultant</h5>

  <p>A Consultant can file on behalf of a company and act as the company representative for a project, providing they have legal consent. This contact type is typically only used for Business Incentive Programs but can also apply for both Entertainment Incentives as well.</p>

  <p>A CONTRACT SIGNATORY must still be assigned in the Project.</p>

  <p>A Consultant contact type CANNOT sign Contract documents.</p>

  <p>There can be multiple Consultant contacts.</p>

  <hr />

  <p><br /></p>

  <h5 id="submission-scenarios">Submission Scenarios<a name="SubScenarios"></a></h5>

  <p>There three processes for submitting a form. The process depends on the account holder Contact Type. The three scenarios are:</p>

  <ul>
    <li>Account Holder is Business Signatory</li>
    <li>Account Holder is Business Contact</li>
    <li>Account Holder is Consultant Contact</li>
  </ul>

  <h6 id="1-account-holder-is-business-signatory-">(1) Account Holder is Business Signatory <a name="Scenario1"></a></h6>

  <p>If the account holder is the Business Signatory, complete the following steps:</p>

  <ul>
    <li>Complete all required fields in the form and upload all necessary attachments.</li>
    <li>Answer “No” to the question “Are you a Third-Party Consultant managing this project on behalf of the business?”</li>
    <li>Add the account holder as the Business Signatory Contact Type in the Project Contact section.
      <ul>
        <li>This section will validate based on the following - 1) a Business Signatory is created and 2) account holder email address is added as a contact.</li>
      </ul>
    </li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/addcontacts.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane form section for adding contact information for a Contract Signatory, with fields for name, title, email, phone, and address."/></p>

  <ul>
    <li>Enter the contact information for a Contract Signatory.</li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/contractsign.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane certification statement and signature input fields for the contract signatory."/></p>

  <ul>
    <li>Check the certification statement, enter the signers name, and sign the form.</li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/certandsign.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane form after completing certification checkbox, entering signer name, and providing signature." /></p>

  <ul>
    <li>Once signed the “Sign” button will become enabled. Click “Sign.”</li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/signform.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane form ready to sign, with the enabled 'Sign' button prominent." /></p>

  <ul>
    <li>The system will notify the user once the signature is accepted. Click “OK” and the system will redirect the user to a read only view of the form.</li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/signok.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane success dialog after form signature: 'Signature accepted' message with 'OK' button." /></p>

  <ul>
    <li>Review the form for errors. If there are errors, click “Unlock for editing” to fix the errors and resign. If there are no errors, click “Pay.”</li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/paybutton.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane read-only form view post-signature, showing 'Pay' button for fee payment." /></p>

  <ul>
    <li>The system will then confirm that the form is ready for payment. Click “Yes.”</li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/areyouready.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane confirmation dialog before proceeding to payment: 'Are you ready?' with 'Yes' option." /></p>

  <ul>
    <li>Complete the information required on the payment screens. Once paid, the system will notify when the form is “Received.”</li>
  </ul>

  <h6 id="2-account-holder-is-business-">(2) Account Holder is Business <a name="Scenario2"></a></h6>

  <p>If the account holder is the Business Contact, complete the following steps</p>

  <ul>
    <li>Complete all required fields in the form and upload all necessary attachments.</li>
    <li>Answer “No” to the question “Are you a Third-Party Consultant managing this project on behalf of the business?”</li>
    <li>Add the account holder as the Business Contact Type in the Project Contact section. Once the Business Contact has been added, then add the Business Signatory Contact.
      <ul>
        <li>This section will validate based on the following - 1) a Business Signatory is created and 2) account holder email address is added as a contact.</li>
      </ul>
    </li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/addcontacts.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane 'Project Contacts' table, showing an empty list with columns for Name, Email Address, Company Name, Phone Number, and Contact Type, plus a highlighted 'Add Project Contact' button."/></p>

  <ul>
    <li>Enter the contact information for a Contract Signatory.</li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/contractsign.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane 'Contract Signatory' form fields for entering first name, last name, title, and email address."/></p>

  <ul>
    <li>Click “Send for Signature.”</li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/sendforsign.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane contract signatory setup with filled details and 'SEND FOR SIGNATURE' button active."/></p>

  <ul>
    <li>The system will then ask a series of questions. The answer to the question, “Will the signee also pay for this form?” will determine the next steps in this flow.
      <ul>
        <li>If the answer is “Yes” the signer will pay immediately after signing.</li>
        <li>The system will notify the Business Signatory via email. The signer will click the link in the email, sign the form and then pay.</li>
        <li>The Business Signatory in this scenario does NOT need an account to sign. The link in the email will give the signer a guest token. This guest token allows the user to sign for five days. After five days, the form must be unlocked by the account holder and resent for signature.</li>
        <li>If the answer is “No” then once the signer signs off on the form, the account holder will receive an email notification when it’s time to pay and complete the submission.</li>
      </ul>
    </li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/bussignok.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane info popup: 'This form requires a signature from Business Signatory' with OK button."/></p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/whopays.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane confirmation dialog asking 'Will the signee also pay for this form?' with Yes/No buttons."/></p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/signemailsent.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane success popup: 'Email Sent' confirming the signature request was emailed to the signatory."/></p>

  <ul>
    <li>The system will notify the Business Signatory via email. The signer will click the link in the email and sign the form. Once signed, the system will let the signer know that the contacts have been notified to pay for the form.</li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/signemail.png" width="800" class="ml-4 boxshadow" alt="Screenshot of an auto-generated email notifying the recipient that a Fastlane form (e.g., Advance for project ID) requires their authorized business signature, with a direct link to review and sign."/></p>

  <ul>
    <li>The Business Contact will then click the link in the email, sign into their account and pay for the form.</li>
    <li>The signer also has the right to decline signature. This may happen for various reasons, but typically, this occurs when information on the form is incorrect. If this happens, the signer will click “I do not wish to sign” and they will need to contact the Business Contact who completed the form. In order for this form to be signed, it will need to go through the send process again.</li>
  </ul>

  <h6 id="3-account-holder-is-consultant-">(3) Account Holder is Consultant <a name="Scenario3"></a></h6>

  <p>If the account holder is the Consultant Contact, complete the following steps:</p>

  <ul>
    <li>Complete all required fields in the form and upload all necessary attachments.</li>
    <li>Answer “Yes” to the question “Are you a Third-Party Consultant managing this project on behalf of the business?” And then generate the Consultant Disclosure.</li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/genCD.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane 'Generate Consultant Disclosure' modal for third-party consultants, with fields for authorized representative name and consultant company name, plus a 'GENERATE DISCLOSURE AUTHORIZATION' button."/></p>

  <ul>
    <li>Upload the signed Consultant Disclosure.</li>
    <li>Add the account holder as the Consultant Contact Type in the Project Contact section. Once the Consultant Contact has been added, then add the Business Signatory Contact.
      <ul>
        <li>This section will validate based on the following: 1) a Business Signatory is created, 2) account holder email address is added as a contact.</li>
      </ul>
    </li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/addcontacts.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane 'Project Contacts' table showing an empty list and highlighted 'Add Project Contact' button for entering signatory details."/></p>

  <ul>
    <li>Enter the contact information for a Contract Signatory.</li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/contractsign.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane 'Contract Signatory' form fields for entering first name, last name, title, and email address."/></p>

  <ul>
    <li>Click “Send for Signature.”</li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/contractsign.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane 'Contract Signatory' section after details are entered, with the 'SEND FOR SIGNATURE' button now enabled."/></p>

  <ul>
    <li>The system will then ask a series of questions. The answer to the question, “Will the signee also pay for this form?” will determine the next steps in this flow.
      <ul>
        <li>If the answer is “Yes” the signer will pay immediately after signing.</li>
        <li>The system will notify the Business Signatory via email. The signer will click the link in the email, sign the form and then pay.</li>
        <li>The Business Signatory in this scenario does NOT need an account to sign. The link in the email will give the signer a guest token. This guest token allows the user to sign for five days. After five days, the form must be unlocked by the account holder and resent for signature.</li>
        <li>If the answer is “No” then once the signer signs off on the form, the account holder will receive an email notification when it’s time to pay and complete the submission.</li>
      </ul>
    </li>
  </ul>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/bussignok.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane info modal: 'This form requires a signature from Business Signatory' with OK button."/></p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/whopays.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane question modal: 'Will the signee also pay for this form?' with Yes/No buttons." /></p>

  <p><img src="https://storage.googleapis.com/fastlane-public-files/Images/HelpImages/signemailsent.png" width="800" class="ml-4 boxshadow" alt="Screenshot of Fastlane success popup: 'Email Sent' confirming the signature request was emailed to the signatory."/></p>

  <ul>
    <li>The system will notify the Business Signatory via email. The signer will click the link in the email and sign the form. Once signed, the system will let the signer know that the contacts have been notified to pay for the form.</li>
    <li>The Consultant Contact will then click the link in the email, sign into their account and pay for the form.</li>
    <li>The signer also has the right to decline signature. This may happen for various reasons, but typically, this occurs when information on the form is incorrect. If this happens, the signer will click “I do not wish to sign” and they will need to contact the Business Contact who completed the form. In order for this form to be signed, it will need to go through the send process again.</li>
  </ul>
</div>
